import { registerBlockType } from "@wordpress/blocks";
import React from "react";
import config, { type BlockAttributes } from "./block.json";
import { InnerBlocks } from "@wordpress/block-editor";
import RowEditor from "./RowEditor";
import { columns } from "@wordpress/icons";
import { registerBlockVariations } from "./variations";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  icon: columns,

  edit: RowEditor,

  save() {
    return <InnerBlocks.Content />;
  },
});

registerBlockVariations();
